export default __webpack_public_path__ + "static/media/Mebooks.0c305d7c.png";